import { render, staticRenderFns } from "./waterMeter.vue?vue&type=template&id=38eded1d&"
import script from "./waterMeter.vue?vue&type=script&lang=js&"
export * from "./waterMeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports